<template>
    <App :isShow="true">
        <div class="latest-news">
            <div class="row">
                <div class="col-sm-12 v-col-md-12 v-col-lg-9 text-center">
                    <SubMenu @onSearch="onSearchHandle" :searchShow="true"/>

                    <v-row>
                        <NewsCardTile
                            v-bind:key="post.id"
                            v-for="post in allArticles"
                            :id="post.id"
                            :title="post.title"
                            :first_name="post.first_name"
                            :last_name="post.last_name"
                            :image="post.image"
                            :categories="post.categories"
                            :created_at="post.created_at"
                            :short_description="post.meta_description"
                            :body="post.body"
                        />
                    </v-row>
                    <div v-if="allArticles.length >= currentPage*12" class="fs-5 mt-3" @click="loadMore" role="button">
                        <span class=" text-grey-darken-1" v-if="isLoading">មើលបន្ថែមទៀត...</span>
                        <span v-else>មើលបន្ថែមទៀត<i class="fa-solid fa-chevron-right fs-6"></i></span>
                    </div>
                    <div v-if="allArticles.length===0" class="text-center h-100">
                        <p class="text-warning ff-koulen fs-18 mt-5">មិនមានអត្ថបទ!</p>
                    </div>
                </div>
                <div class="v-col-sm-12 v-col-md-12 v-col-lg-3">
                    <RightSideBar />
                </div>
            </div>
        </div>
    </App>
</template>

<script setup>
import App from "../Layouts/App";
import RightSideBar from "../Components/RightSideBar.vue";
import NewsCardTile from "../Components/NewsCardTile.vue";
import {computed, reactive, ref, inject, provide} from "vue";
import axios from "axios";
import SubMenu from "../Components/Share/SubMenu.vue";
import {Inertia} from "@inertiajs/inertia";
import FloatingAudioPlayer from "../Components/FloatingAudioPlayer.vue";
const props = defineProps({
    posts: Array,
    popular: Array,
    search: String,
    searchShow: true,
    isShow: true
});


const allArticles = ref(props.posts);
const currentPage = ref(1);
const isLoading = ref(false);
const search = ref('');

async function onSearchHandle(newSearch) {
    search.value = newSearch;
    Inertia.visit('/search/news', {
        method: 'get',
        data: {
            search: newSearch,
        },
        preserveState: true,
        replace: true,
        only: ['countPosts','search','posts','slug'],
    });
}

async function loadMore() {
    isLoading.value = true
    const response = await axios.get(route('list'), {
        params: {
            page: currentPage.value + 1,
        },
    });
    isLoading.value = false

    const data = response.data.data;
    if (data?.length) {
        allArticles.value.push(...data);
    }
    currentPage.value++;
}

const currentPostIndex = ref(0);

function nextPost () {
    if (currentPostIndex.value < props.popular.length - 1) {
        currentPostIndex.value++;
    }
}

function prevPost () {
    if (currentPostIndex.value > 0) {
        currentPostIndex.value--;
    }
}

</script>

<style scoped>
.custom-card {
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.custom-card img {
    height: 200px;
    object-fit: cover;
    width: 100%;
}

.card-body h5 {
    color: #f08c22; /* Orange heading */
    font-weight: bold;
}

.card-text-small {
    color: #6c757d;
    font-size: 14px;
}

.container-custom {
    margin-top: 30px;
}

.truncate-text {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}
</style>
